<template>
  <CyclingToSchool />
</template>

<script>
import CyclingToSchool from '@/components/cyclingToSchoolCard.vue';

export default {
  components: {
    CyclingToSchool,
  },
};
</script>

<style></style>
